<header class="header--well">
    <ul>
        <li class="header__title">
            <h2>AZ MVD Now Customer Details</h2>
        </li>
        <li>
            <ul class="list--views">
                <li>
                    <a class="list__link" href="javascript:void(0);" (click)="emitDocumentSelected()">View Customer Documents</a>
                </li>
            </ul>
        </li>
    </ul>
</header>

<validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
<div class="well">
    <ng-container *ngIf="vehicleData">
        <h2>Customer Title</h2>
        <p-table [value]="vehicleData" [responsive]="true" styleClass="p-datatable-striped">
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="5">
                        No records found
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th class="w--date">Year</th>
                    <th>Make</th>
                    <th>Model</th>
                    <th>Plate Number</th>
                    <th class="w--icon">View</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr [pSelectableRow]="data">
                    <td>{{data.vehicleYear}}</td>
                    <td>{{data.make}}</td>
                    <td>{{data.model}}</td>
                    <td>{{data.plateNumber}}</td>
                    <td class="text-center"> <a class="icon--view" title="View Title" href="javascript:void(0)" (click)="emitTitleSelected(data.vehicleId)"></a></td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer" let-columns>
                <tr>
                    <td [attr.colspan]="5">
                        <span class="disclaimer"> Disclaimer: Vehicles with title and active registration only.</span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </ng-container>

    <assisted-self-service-invitation-list></assisted-self-service-invitation-list>

    <ng-container *ngIf="!loading && showMobileId">
        <h2>Mobile Identification</h2>
        <div class="mvd_form-group">
            <div class="mvd_form__mvd_alert">
                <span class="mvd_alert--message__info" *ngIf="mobileIdAuthorization?.mobileIdentificationCustomerAuthorizationStatusTypeId == mobileIdentificationCustomerAuthorizationStatusType.CustomerPrequalified.id">The user is currently prequalified.</span>
                <span class="mvd_alert--message__warning" *ngIf="isCustomerMobileIdOptedOut && (mobileIdAuthorization?.mobileIdentificationCustomerAuthorizationStatusTypeId != mobileIdentificationCustomerAuthorizationStatusType.CustomerPrequalified.id)"><i class="material-icons"></i> Customer is opted out.</span>
            </div>
            <button class="btn--primary btn--tight" [disabled]="mobileIdAuthorization?.mobileIdentificationCustomerAuthorizationStatusTypeId == mobileIdentificationCustomerAuthorizationStatusType.CustomerPrequalified.id" (click)="prequalifyMobileIdentification()">
                <ng-container *ngIf="mobileIdAuthorization?.mobileIdentificationCustomerAuthorizationStatusTypeId != mobileIdentificationCustomerAuthorizationStatusType.CustomerPrequalified.id">Prequalify</ng-container>
                <ng-container *ngIf="mobileIdAuthorization?.mobileIdentificationCustomerAuthorizationStatusTypeId == mobileIdentificationCustomerAuthorizationStatusType.CustomerPrequalified.id">Currently Prequalified</ng-container>
            </button>
            <button class="btn--primary btn--tight"
                    [disabled]="mobileIdAuthorization?.mobileIdentificationCustomerAuthorizationStatusTypeId == mobileIdentificationCustomerAuthorizationStatusType.ForcedExtendedReview.id"
                    (click)="forcedExtendedReviewMobileIdentification()">
                <ng-container *ngIf="mobileIdAuthorization?.mobileIdentificationCustomerAuthorizationStatusTypeId != mobileIdentificationCustomerAuthorizationStatusType.ForcedExtendedReview.id">Require Extended Review</ng-container>
                <ng-container *ngIf="mobileIdAuthorization?.mobileIdentificationCustomerAuthorizationStatusTypeId == mobileIdentificationCustomerAuthorizationStatusType.ForcedExtendedReview.id">Extended Review Required</ng-container>
            </button>
        </div>

        <h2>Current Mobile Identification</h2>
        <p-table [autoLayout]="true" [value]="currentMobileIds" sortField="requestedDate" sortOrder="-1" styleClass="p-datatable-striped">
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="7">
                        No records found
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th class="w--date-time">Request Date</th>
                    <th>Mobile Credential Type</th>
                    <th>Prequalified</th>
                    <th>Mobile Credential Action</th>
                    <th>Status Reason</th>
                    <th>User</th>
                    <th class="w--actions">Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr [pSelectableRow]="data">
                    <td>{{data.requestedDate | date:'short'}}</td>
                    <td>{{data.mobileIdentificationCredentialTypeDisplayValue}}</td>
                    <td>{{data.isPrequalified ? 'Yes' : 'No' }}</td>
                    <td>{{data.mobileIdentificationStatusTypeDisplayValue}}</td>
                    <td>{{data.mobileIdentificationStatusReasonTypeDisplayValue}}</td>
                    <td class="td--hover-show">{{data.updatedBy}}</td>
                    <td>
                        <!-- Prequalify / Deny -->
                        <ng-container *ngIf="(data.mobileIdentificationStatusTypeId == mobileIdentificationStatusTypes.ExtendedReview
                                || data.mobileIdentificationStatusTypeId == mobileIdentificationStatusTypes.Pending) && data.mobileIdentificationCredentialTypeId != mobileIdentificationCredentialTypes.IdemiaMDL">
                            <a href="javascript:void(0)" class="icon--done_all" title="Prequalify"
                                    [class.disabled]="mobileIdAuthorization?.mobileIdentificationCustomerAuthorizationStatusTypeId == mobileIdentificationCustomerAuthorizationStatusType.CustomerPrequalified.id &&
                                    data.mobileIdentificationStatusTypeId != mobileIdentificationStatusTypes.Pending"
                                    (click)="prequalifyMobileIdentificationRequest(data.id)">
                            </a>
                            <a href="javascript:void(0)" class="icon--nay" title="Deny" (click)="confirmDenyMobileIdentification(data.mobileIdentificationCredentialTypeId)"></a>
                        </ng-container>
                        <!-- Pause an Active Mobile ID-->
                            <a class="icon--pause" href="javascript:void(0);" title="Pause" (click)="confirmPauseMobileIdentification(data.id)" *ngIf="data.mobileIdentificationStatusTypeId == mobileIdentificationStatusTypes.Active
                                && (data.mobileIdentificationCredentialTypeId == mobileIdentificationCredentialTypes.AppleMDL.id
                                || data.mobileIdentificationCredentialTypeId == mobileIdentificationCredentialTypes.IdemiaMDL.id
                                || data.mobileIdentificationCredentialTypeId == mobileIdentificationCredentialTypes.SamsungMDL.id
                                || data.mobileIdentificationCredentialTypeId == mobileIdentificationCredentialTypes.AzWalletMDL.id)"></a>
                        <!-- Resume a Suspended Mobile ID-->
                            <a class="icon--spinner" href="javascript:void(0);" title="Resume" (click)="confirmResumeMobileIdentification(data.id)" *ngIf="data.mobileIdentificationStatusTypeId == mobileIdentificationStatusTypes.Suspended
                                && (data.mobileIdentificationCredentialTypeId == mobileIdentificationCredentialTypes.AppleMDL.id
                                || data.mobileIdentificationCredentialTypeId == mobileIdentificationCredentialTypes.IdemiaMDL.id
                                || data.mobileIdentificationCredentialTypeId == mobileIdentificationCredentialTypes.SamsungMDL.id
                                || data.mobileIdentificationCredentialTypeId == mobileIdentificationCredentialTypes.AzWalletMDL.id)"></a>
                    </td>
                </tr>
            </ng-template>
        </p-table>

        <h2>Mobile Identification Devices</h2>
        <p-table [autoLayout]="true" [value]="mobileProvisioningBundles" sortField="createdDate" sortOrder="-1" styleClass="p-datatable-striped">
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="6">
                        No records found
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th class="w--date-time">Created Date</th>
                    <th>Mobile Credential Type</th>
                    <th>Status</th>
                    <th>Device Type</th>
                    <th class="w--date-time">Updated Date</th>
                    <th class="w--actions">Unlink</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr [pSelectableRow]="data">
                    <td>{{data.createdDate | date:'short'}}</td>
                    <td>{{data.mobileIdentificationCredentialTypeDisplayValue}}</td>
                    <td>{{data.mobileIdentificationProvisioningBundleStatusTypeDisplayValue}}</td>
                    <td>{{data.mobileIdentificationDeviceTypeDisplayValue}}</td>
                    <td>{{data.updatedDate | date:'short'}}</td>
                    <td class="text-center">
                        <!-- Unlink an Active Mobile Provisioning Bundle ID-->
                        <a href="javascript:void(0);" title="Unlink" (click)="confirmUnlinkMobileProvisioningBundleId(data.id)" [ngClass]="{'disabled': bundleUnlinkInProgress || (data.mobileIdentificationCredentialTypeId == mobileIdentificationCredentialTypes.IdemiaMDL)}" *ngIf="data.mobileIdentificationProvisioningBundleStatusTypeId == mobileIdentificationProvisioningBundleStatusType.Active"><i class="material-icons">link_off</i></a>
                    </td>
                </tr>
            </ng-template>
        </p-table>

        <h2>Mobile Identification Number History</h2>
        <p-table [autoLayout]="true" [value]="mobileIdHistory" [rows]="15" [paginator]="true" sortField="requestedDate" sortOrder="-1" styleClass="p-datatable-striped">
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="7">
                        No records found
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th class="w--date-time">Request Date</th>
                    <th>Mobile Credential Type</th>
                    <th>Prequalified</th>
                    <th>Mobile Credential Action</th>
                    <th>Status Reason</th>
                    <th>User</th>
                    <th class="w--date-time">Updated Date</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr [pSelectableRow]="data">
                    <td>{{data.requestedDate | date:'short'}}</td>
                    <td>{{data.mobileIdentificationCredentialTypeDisplayValue}}</td>
                    <td>{{data.isPrequalified ? 'Yes' : 'No' }}</td>
                    <td>{{data.mobileIdentificationStatusTypeDisplayValue}}</td>
                    <td>{{data.mobileIdentificationStatusReasonTypeDisplayValue}}</td>
                    <td class="td--hover-show">{{data.updatedBy}}</td>
                    <td>{{data.updatedDate | date:'short'}}</td>
                </tr>
            </ng-template>
        </p-table>

        <h2>Customer Authorization History</h2>
        <p-table [autoLayout]="true" [value]="customerAuthorizationHistory" [rows]="15" [paginator]="true" sortField="updatedDate" sortOrder="-1" styleClass="p-datatable-striped">
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="3">
                        No records found
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th class="w--190">Status</th>
                    <th>User</th>
                    <th class="w--date-time">Updated Date</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr [pSelectableRow]="data">
                    <td>{{getMobileIdentificationStatusTypes(data)}}</td>
                    <td>{{data.updatedBy}}</td>
                    <td>{{data.updatedDate | date:'short'}}</td>
                </tr>
            </ng-template>
        </p-table>
    </ng-container>

    <ng-container *ngIf="mvdNowStatus">
        <h2>AZ MVD Now Account Options</h2>
        <ul class="list--bulletless--content">
            <ng-container *ngIf="mvdNowStatus.userExistsInMvdNow">
                <li>AZ MVD Now Email Address: {{mvdNowStatus.username}} <ng-container *ngIf="mvdNowStatus.issuer">({{mvdNowStatus.issuer}})</ng-container></li>
                <li><a href="javascript:void(0)" (click)="exceptionLogClick()"><i class="material-icons">list</i> Exception Log</a></li>
                <li><a href="javascript:void(0)" class="icon--link" (click)="toggleMvdNowAccess()" *ngIf="!mvdNowStatus.userAccessToMvdNowEnabled"> Enable AZ MVD Now Access.</a></li>
                <li><a href="javascript:void(0)" (click)="toggleMvdNowAccess()" *ngIf="mvdNowStatus.userAccessToMvdNowEnabled"><i class="material-icons">block</i> Disable AZ MVD Now Access.</a></li>
                <li><a href="javascript:void(0)" (click)="resetPhoneAuthenticationMethod()" *ngIf="mvdNowStatus.userAccessToMvdNowEnabled" [ngClass]="{'disabled': mfaResetInProgress}"><i class="material-icons">smartphone</i> Reset AZ MVD Now Sign-in Verification Phone Number.</a></li>
                <li><a href="javascript:void(0)" (click)="changeEmail()" *ngIf="mvdNowStatus.userAccessToMvdNowEnabled"><i class="material-icons">email</i> Change AZ MVD Now Email Address.</a></li>
            </ng-container>
            <li *ngIf="!mvdNowStatus.userExistsInMvdNow"><a href="javascript:void(0)" (click)="linkToMvdNow()"><i class="material-icons">link</i> Link customer to AZ MVD Now user.</a></li>
            <li *ngIf="mvdNowStatus.userExistsInMvdNow && mvdNowStatus.userAccessToMvdNowEnabled"><a href="javascript:void(0)" (click)="unlinkFromMvdNow()"><i class="material-icons">clear</i> Unlink all customer and associated accounts from AZ MVD Now user.</a></li>
            <li *ngIf="mvdNowStatus.userExistsInMvdNow && mvdNowStatus.enhancedAuthenticationActive"><a href="javascript:void(0)" (click)="deactivateEnhancedAuthentication()"><i class="material-icons">clear</i> Deactivate enhanced authentication for AZ MVD Now user.</a></li>
            <ng-container *ngIf="mvdNowStatus.userExistsInMvdNow">
                <li *ngIf="mvdNowStatus.userHasValidEIdCredential"><a href="javascript:void(0)" (click)="revokeEIdCredentials()"><i class="material-icons">block</i> Disable eID identification for AZ MVD Now user.</a></li>
                <li *ngIf="!mvdNowStatus.userHasValidEIdCredential && mvdNowStatus.userHasHistoricalEIdCredential"><a class="icon--link" href="javascript:void(0)" (click)="reinstateEIdCredentials()"> Enable eId identification for AZ MVD Now user.</a></li>
            </ng-container>
            <ng-container *ngIf="mvdNowStatus.userExistsInMvdNow">
                <li *ngIf="idemiaMId && idemiaMId.registrationStatus != 'CANCELLED'">
                    <a href="javascript:void(0)" (click)="revokeMIdCredentials()"><i class="material-icons">block</i> Disable Idemia MobileID for AZ MVD Now user.</a>
                </li>
                <li *ngIf="idemiaMId && idemiaMId.registrationStatus == 'CANCELLED'">
                    <a class="icon--link" href="javascript:void(0)" (click)="reinstateMIdCredentials()"> Enable Idemia MobileID for AZ MVD Now user.</a>
                </li>
                <li *ngIf="(idemiaMId && idemiaMId.registrationStatus != 'CANCELLED') || hasActiveV4IdemiaMId">
                    <a href="javascript:void(0)" (click)="updateMIdCredentials()"><i class="material-icons">replay</i> Request Idemia MobileID App Update.</a>
                </li>
            </ng-container>
            <ng-container *ngIf="mvdNowStatus.userExistsInMvdNow">
                <li *ngIf="mvdNowStatus.accountVerificationEnabled"><a href="javascript:void(0)" (click)="resetMVDNowAccountVerification()"><i class="material-icons">replay</i> Reset AZ MVD Now Account Verification.</a></li>
            </ng-container>
            <ng-container *ngIf="!loading">
                <li *ngIf="mobileIdAuthorization?.mobileIdentificationCustomerAuthorizationStatusTypeId == mobileIdentificationCustomerAuthorizationStatusType.MDLRestricted.id">
                    <a href="javascript:void(0)" (click)="unrestrictMobileIdentification()"><i class="material-icons">clear</i> Unrestrict Mobile Identification for AZ MVD Now.</a>
                </li>
                <li *ngIf="mobileIdAuthorization?.mobileIdentificationCustomerAuthorizationStatusTypeId != mobileIdentificationCustomerAuthorizationStatusType.MDLRestricted.id">
                    <a href="javascript:void(0)" (click)="restrictMobileIdentification()"><i class="material-icons">block</i> Restrict Mobile Identification for AZ MVD Now.</a>
                </li>
            </ng-container>
        </ul>
    </ng-container>
</div>
